import { render, staticRenderFns } from "./Jamie.vue?vue&type=template&id=37ce2d0c&scoped=true&"
import script from "./Jamie.vue?vue&type=script&lang=ts&"
export * from "./Jamie.vue?vue&type=script&lang=ts&"
import style0 from "./Jamie.vue?vue&type=style&index=0&id=37ce2d0c&scoped=true&lang=css&"
import style1 from "./Jamie.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce2d0c",
  null
  
)

export default component.exports